export default class Label {
  constructor({ 
    id, 
    text = '', 
    x = 0, 
    y = 0, 
    layerId = null, 
    color = '#ffffff', 
    selected = false, 
    fontSize = 12, 
    fontType = 'monospace',  // <-- Added
    rotation = 0 ,
    justification = 'centerleft' // <-- Added
  }) {
    this.id = id;   
    this.type = "label";
    this.text = text;
    this.x = x;
    this.y = y;
    this.layerId = layerId;
    this.color = color;
    this.selected = selected;
    this.fontSize = fontSize;
    this.fontType = fontType; // <-- Added
    this.rotation = rotation;
    this.justification = justification; // <-- Added
  }
}
